import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useReactFlow } from 'reactflow';
import { CONTENT_MAX_WIDTH } from 'components/Layout/PageContentWidth';
import { getAutomation, getShowStats } from '../store/selectors';
import { useAutomationsSelector } from '../store/react';
import ZoomControl from './ZoomControl';
import { getAutomationStatsConfig } from '../helpers';
import { Statistic } from 'ts-components/AutomationEngine/ControlBar/Statistic';
import { FLOW_BAR_HEIGHT } from './constants';

const FlowBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: ${FLOW_BAR_HEIGHT}px;
  min-height: ${FLOW_BAR_HEIGHT}px;
  padding: 0 15px;
  > div {
    display: flex;
    justify-content: space-between;
    flex: 1;
    max-width: ${CONTENT_MAX_WIDTH};
  }
`;
const StatsPanel = styled.div`
  > * {
    margin-top: 18px;
    margin-left: 10px;
    margin-right: 10px;
  }
`;
const ZoomPanel = styled.div`
  > * {
    margin-top: 15px;
  }
`;

export const FlowBar = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const automation = useAutomationsSelector(getAutomation);
  const stats = useAutomationsSelector((state) => state.stats);
  const showStats = useAutomationsSelector(getShowStats);
  const { zoomIn, zoomOut } = useReactFlow();

  const statsActive = Boolean(showStats && stats);

  const statsConfig = useMemo(
    () => getAutomationStatsConfig(automation, statsActive, t),
    [automation, statsActive, t]
  );

  return (
    <FlowBarWrapper {...props} ref={ref}>
      <div>
        <StatsPanel data-qa={statsActive ? 'automation-stats' : undefined}>
          {statsConfig.map(({ label, tooltipLabel, value, href, status }) => (
            <Statistic
              key={status}
              label={label}
              tooltipLabel={tooltipLabel}
              value={value}
              href={href}
              status={status}
            />
          ))}
        </StatsPanel>
        <ZoomPanel>
          <ZoomControl
            onClickPlus={() =>
              zoomIn({
                duration: 0,
              })
            }
            onClickMinus={() =>
              zoomOut({
                duration: 0,
              })
            }
          />
        </ZoomPanel>
      </div>
    </FlowBarWrapper>
  );
});
